<template>
  <section class="car-showcase" :class="showcaseClass">
    <!-- 渐变背景 -->
    <!-- <div class="showcase-bg"></div> -->
    <div class="showcase-content">
      <!-- {{ carShowList }} -->
      <!-- <div class="hq-title1">探索iCAUR</div> -->
      <!-- 主轮播区域 -->
      <div class="main-carousel-wrapper">
        <swiper
          v-if="thumbsSwiperInstance"
          ref="mainSwiper"
          class="main-swiper"
          :options="mainSwiperOptions"
          @ready="onMainSwiper"
          @slideChange="onSlideChange"
          @slideChangeTransitionStart="onTransitionStart"
          @slideChangeTransitionEnd="onTransitionEnd"
        >
          <swiper-slide v-for="car in carShowList" :key="car.id">
            <div class="car-slide">
              <!-- 右侧车辆展示 -->
              <div class="car-visual">
                <div class="car-image-wrapper">
                  <!-- 车身图片 -->
                  <img alt="" :src="car.highImg" class="car-body-img" />
                  <!-- 前轮毂 -->
                  <img alt="" :src="car.frontImg" class="car-wheel car-wheel-front" />
                  <!-- 后轮毂 -->
                  <img alt="" :src="car.frontImg" class="car-wheel car-wheel-rear" />
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <!-- 底部缩略图导航 -->
        <div class="thumbnails-wrapper">
          <swiper
            ref="thumbsSwiper"
            class="thumbs-swiper"
            :options="thumbsSwiperOptions"
            @ready="onThumbsSwiper"
          >
            <swiper-slide
              :key="car.id"
              class="thumb-slide"
              v-for="(car, index) in carShowList"
            >
              <div
                class="thumb-item"
                @click="onThumbClick(index)"
                :class="{ 'thumb-active': activeIndex === index }"
              >
                <img alt="" class="thumb-img" :src="car.modeLogo" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="btn" :class="{ 'btn-show': btnShow }" @click="goNewPage2()">
          <div class="btn-inside">探索</div>
        </div>
      </div>
      <!-- {{ activeIndex }} -->
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "CarShowcase",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    carShowList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      btnShow: true,
      carIndex2: 0,
      activeIndex: 1,
      isTransitioning: false,
      // 轮毂旋转方向：'cw'=顺时针(right→left)，'ccw'=逆时针(left→right)
      wheelDir: "cw",
      mainSwiperInstance: null,
      thumbsSwiperInstance: null,
      // 缩略图轮播配置（先于主轮播初始化）
      thumbsSwiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 16,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: false,
      },
      mainSwiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1200,
        grabCursor: true,
        thumbs: {
          swiper: this.thumbsSwiperInstance,
        },
        // on: {
        //   transitionStart: () => {
        //     this.btnShow = false;
        //   },
        //   transitionEnd: () => {
        //     this.btnShow = true;
        //   },
        // },
      },
    };
  },
  computed: {
    // 主轮播配置：等缩略图轮播就绪后再初始化主轮播，保证 thumbs 关联生效
    // mainSwiperOptions() {
    //   return {
    //     slidesPerView: 1,
    //     spaceBetween: 0,
    //     loop: true,
    //     speed: 1200,
    //     grabCursor: true,
    //     thumbs: {
    //       swiper: this.thumbsSwiperInstance,
    //     },
    //   };
    // },
    // 动画状态类挂在根节点上，loop 模式克隆出的 slide 也能命中样式
    showcaseClass() {
      return {
        "is-moving": this.isTransitioning,
        "wheel-cw": this.isTransitioning && this.wheelDir === "cw",
        "wheel-ccw": this.isTransitioning && this.wheelDir === "ccw",
      };
    },
  },
  methods: {
    onMainSwiper(swiper) {
      this.mainSwiperInstance = swiper;
    },
    onThumbsSwiper(swiper) {
      this.thumbsSwiperInstance = swiper;
    },
    onSlideChange() {
      this.activeIndex = this.$refs.mainSwiper.$swiper.realIndex;
      // console.log("    this.activeIndex  :>> ", this.activeIndex);
    },
    onTransitionStart() {
      let { activeIndex, previousIndex } = this.$refs.mainSwiper.$swiper;
      this.isTransitioning = true;
      // 判断滑动方向：activeIndex > previousIndex 即向左滑，车轮顺时针
      this.wheelDir = activeIndex > previousIndex ? "cw" : "ccw";
    },
    onTransitionEnd() {
      this.isTransitioning = false;
    },
    // 点击缩略图手动切换主轮播
    onThumbClick(index) {
      console.log("index :>> ", index);
      if (this.activeIndex === index) return false;
      console.log("onThumbClick :>> 333");

      if (this.mainSwiperInstance) {
        this.mainSwiperInstance.slideToLoop(index);
      }
    },
    goNewPage2() {
      const car = this.carShowList[this.activeIndex];
      if (!car || !car.modelName) return;
      const p = `/models/${car.modelName.toLowerCase()}`;
      console.log("item :>> ", p);
      this.$router
        .push({ path: p })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.hq-title1 {
  font-size: 26px;
  padding-bottom: 20px;
}
/* 整体容器  */
.car-showcase {
  position: relative;
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  /* background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 30%, #16213e 60%, #0f3460 100%); */
}

.showcase-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  /* background:
    radial-gradient(ellipse at 30% 20%, rgba(15, 52, 96, 0.4) 0%, transparent 60%),
    radial-gradient(ellipse at 70% 80%, rgba(26, 26, 46, 0.6) 0%, transparent 50%); */
  pointer-events: none;
}

.showcase-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  // padding: 40px 0 0;
}

/* ========== 主轮播区域 ========== */
.main-carousel-wrapper {
  position: relative;
  flex: 1;
  width: 100%;
  max-width: 100vw;
  display: flex;
  align-items: center;
  overflow: hidden;

  /* background-color: #f1f1f1; */
  background-image: url("@/assets/img/web3dBg.webp");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.main-swiper {
  width: 100%;
  height: 100%;
}

.main-swiper ::v-deep .swiper-wrapper,
.main-swiper ::v-deep .swiper-slide {
  width: 100%;
  height: 100%;
}

.car-slide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  // padding: 0 8%;
  gap: 4%;
  box-sizing: border-box;
}
.btn {
  position: absolute;
  left: 50%;
  bottom: 100px;
  transform: translate(-50%, -50%);
  width: 140px;
  line-height: 46px;
  font-size: 22px;
  text-align: center;
  font-weight: 500;
  // border: #fff solid 1px;
  border-radius: 5px;
  color: #000;
  cursor: pointer;
  z-index: 999;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.1s ease;
}

.btn-show {
  opacity: 1;
}

.btn-inside {
  position: relative;
  width: 100%;
  height: 100%;
  transition: color 0.35s ease;
  background-color: #fff;
  z-index: 1000;
}

.btn-inside::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.35s ease;
  z-index: -1;
}
.btn:hover {
  color: #fff;
}

.btn-inside:hover::before {
  transform: scaleX(1);
}
.car-tagline {
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.4rem;
  margin-bottom: 1.6rem;
  text-transform: uppercase;
}
.car-name {
  font-size: 4.2rem;
  font-weight: 700;
  margin-bottom: 3.2rem;
  line-height: 1.15;
  letter-spacing: -0.1rem;
}

.car-dimensions {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3.2rem;
  padding: 1.6rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.dim-item {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
}

.dim-label {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

.dim-value {
  font-size: 1.8rem;
  font-weight: 600;
}

.dim-divider {
  width: 1px;
  height: 2.4rem;
  background: rgba(255, 255, 255, 0.2);
}

.car-links {
  display: flex;
  gap: 1.6rem;
}

.car-link {
  display: inline-block;
  padding: 1rem 2.4rem;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 0.4rem;
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  transition: all 0.3s ease;
}

.car-link:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.8);
}

/* ========== 右侧车辆视觉 ========== */
.car-visual {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.car-image-wrapper {
  position: relative;
  width: 120%;
  // width: 100%;
  max-width: 1100px;
  /* max-width: 102rem; */
  /* aspect-ratio: 1042 / 355; */
  /* filter: drop-shadow(0 2rem 4rem rgba(0, 0, 0, 0.4)); */
}

/* 滑动中（动画状态类挂在根节点，loop 克隆节点同样生效） */
.car-showcase.is-moving .car-image-wrapper {
  transform: scale(1);
  transition: transform 0.3s ease;
}

.car-body-img {
  display: block;
  // width: 100%;
  width: 120%;
  height: 100%;
  object-fit: contain;
}

/* ========== 车轮覆盖层 ========== */
.car-wheel {
  position: absolute;
  /* 轮毂大小：参考站点 1.37rem / 10.42rem ≈ 13.1% */
  /* width: 13.1%; */
  /* width: 12.4%; */
  width: 12.5%;
  height: auto;
  aspect-ratio: 1 / 1;
  z-index: 2;
  transform-origin: center center;
}

/* 前轮：left 1.8rem / 10.42rem ≈ 17.3%，top 1.91rem / 3.4rem ≈ 56.2% */
/* .car-wheel-front {
  top: 53%;
  left: 17.5%;
} */
.car-wheel-front {
  top: 58.5%;
  left: 17.92%;
}

/* 后轮：right 2.32rem / 10.42rem ≈ 22.3%，top 同前轮 */
/* .car-wheel-rear {
  top: 53.1%;
  right: 22.1%;
} */
.car-wheel-rear {
  top: 58%;
  right: 25.2%;
}

/* ========== 车轮滚动动画 ========== */
/* 顺时针（向左滑动，车从右往左进入） */
.car-showcase.wheel-cw .car-wheel {
  animation: wheel-spin-cw 1.2s linear infinite;
}

/* 逆时针（向右滑动，车从左往右进入） */
.car-showcase.wheel-ccw .car-wheel {
  animation: wheel-spin-ccw 1.2s linear infinite;
}

@keyframes wheel-spin-cw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes wheel-spin-ccw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* ========== 自定义导航箭头 ========== */
.custom-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1rem);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.custom-nav:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.6);
}

.custom-nav.swiper-button-disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}

.custom-next {
  right: 3rem;
}

/* ========== 底部缩略图导航 ========== */
.thumbnails-wrapper {
  position: absolute;
  left: 50%;
  top: 128px;
  transform: translate(-50%, -50%);
  // padding: 2rem 6rem 3.2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 100;
  .thumbs-swiper {
    width: 100%;
    ::v-deep .swiper-wrapper {
      display: flex;
      align-items: center;
    }
  }
}

.thumbs-swiper ::v-deep .swiper-slide {
  width: auto !important;
}

.thumb-slide {
  cursor: pointer;
}

.thumb-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  padding: 50px 20px;
  border-radius: 0.8rem;
  transition: all 0.3s ease;
  width: 140px;
}

.thumb-item:hover {
  background: rgba(000, 000, 000, 0.2);
}

.thumb-item.thumb-active {
  background: rgba(000, 000, 000, 0.2);
}

.thumb-item.thumb-active .thumb-name {
  color: #ffffff;
  font-weight: 700;
}

.thumb-img {
  width: 10rem;
  height: auto;
  // opacity: 0.6;
  transition: all 0.3s ease;
  // filter: brightness(0.8);
}

.thumb-active .thumb-img {
  opacity: 1;
  filter: brightness(1);
  transform: scale(1.05);
}

.thumb-name {
  font-size: 1.4rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.3s ease;
}

.thumb-variant {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.1rem;
}

/* ========== 响应式 ========== */
@media (max-width: 1024px) {
  .car-slide {
    flex-direction: column;
    // padding: 4rem 6% 2rem;
    gap: 2rem;
  }

  .car-name {
    font-size: 3.2rem;
  }

  .car-dimensions {
    justify-content: center;
  }

  .car-links {
    justify-content: center;
  }

  .car-visual {
    flex: 1;
    width: 100%;
    // width: 110%;
  }

  .car-image-wrapper {
    max-width: 55rem;
  }

  .custom-nav {
    width: 4rem;
    height: 4rem;
  }

  .custom-next {
    right: 1.2rem;
  }

  .thumbnails-wrapper {
    // padding: 1.6rem 3rem 2.4rem;
  }
}

@media (max-width: 640px) {
  .car-name {
    font-size: 2.6rem;
  }

  .car-tagline {
    font-size: 1.1rem;
    letter-spacing: 0.2rem;
  }

  .car-visual {
    flex: 1;
    width: 120%;
  }
  .car-image-wrapper {
    max-width: 38rem;
  }

  .car-dimensions {
    gap: 1.2rem;
  }

  .car-links {
    flex-direction: column;
    align-items: center;
  }

  .thumbnails-wrapper {
    // padding: 1.2rem 2rem 2rem;
  }
}
</style>
